export default __webpack_public_path__ + "static/media/arrow-down.eea617a8.svg";